import React from 'react'

import { Table } from 'components/shared/Table/Table'

import styles from './PlaceholderRow.module.scss'

export const PlaceholderRow = ({ placeholder: { title, text = '' } }) => (
  <Table.Row className={styles.row}>
    <Table.Cell className={styles.cell} colSpan={20} type="body">
      <span className={styles.content}>
        <span className={styles.title}>{title}</span>
        {text && <span className={styles.text}>{text}</span>}
      </span>
    </Table.Cell>
  </Table.Row>
)
